<template>
    <div class="saas-page linear-log-page">
        <div class="saas-hero card-saas linear-page-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{trans('mail.email_log')}}</span>
                </p>
                <span class="linear-eyebrow">{{trans('mail.email_log')}}</span>
                <h1 class="saas-hero__title">{{trans('mail.email_log')}}</h1>
            </div>
        </div>
        <div class="admin-list-table-card linear-table-card mt-3" v-if="email_logs.total">
            <div class="linear-section-head linear-section-head--table">
                <div>
                    <span>{{trans('mail.email_log')}}</span>
                    <h4>{{trans('mail.email')}}</h4>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table admin-data-table linear-dense-table mb-0">
                    <thead>
                        <tr>
                            <th>{{trans('mail.receiver')}}</th>
                            <th>{{trans('mail.subject')}}</th>
                            <th>{{trans('mail.sent_at')}}</th>
                            <th class="admin-table-actions-cell">{{trans('general.actions')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="email_log in email_logs.data" :key="email_log.id">
                            <td>
                                <span class="linear-table-primary" v-text="email_log.to_address"></span>
                            </td>
                            <td>
                                <span class="linear-table-muted linear-table-truncate" v-text="email_log.subject"></span>
                            </td>
                            <td><span class="linear-table-muted">{{email_log.created_at | moment }}</span></td>
                            <td class="admin-table-actions-cell">
                                <table-row-action-dropdown>
                                    <b-dropdown-item-button data-toggle="modal" data-target=".email-log-detail" @click="fetchEmailLog(email_log)">
                                        <admin-icon name="eye"></admin-icon> {{ trans('mail.view') }}
                                    </b-dropdown-item-button>
                                    <b-dropdown-item-button
                                        v-confirm="{ok: confirmDelete(email_log)}"
                                        class="admin-row-actions__danger"
                                    >
                                        <admin-icon name="trash"></admin-icon> {{ trans('general.delete') }}
                                    </b-dropdown-item-button>
                                </table-row-action-dropdown>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="admin-table-pagination-wrap">
                <pagination-record :page-length.sync="filterEmailLogForm.page_length" :records="email_logs" @updateRecords="getEmailLogs" @change.native="getEmailLogs"></pagination-record>
            </div>
        </div>
        <div class="admin-list-table-card admin-empty-state linear-empty-state mt-3" v-if="!email_logs.total" role="status">
            <div class="admin-empty-state__inner">
                <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                    <admin-icon name="mail"></admin-icon>
                </div>
                <h4 class="admin-empty-state__title">{{ trans('general.no_result_found') }}</h4>
                <p class="admin-empty-state__text">{{trans('mail.email_log')}}</p>
            </div>
        </div>
        <div class="modal fade email-log-detail admin-modal-pro" tabindex="-1" role="dialog" aria-labelledby="emailLogDetail" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content admin-modal-pro__content linear-email-modal">
                    <div class="modal-header">
                        <h4 class="modal-title" id="emailLogDetail">{{trans('mail.email')}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body" v-if="email_log">
                        <div class="linear-email-modal__head">
                            <div>
                                <span>{{trans('mail.subject')}}</span>
                                <h4>{{email_log.subject}}</h4>
                            </div>
                            <time>{{email_log.created_at | moment}}</time>
                        </div>
                        <div class="linear-email-modal__meta">
                            <p>{{trans('mail.sender')+': '+email_log.from_address}}</p>
                            <p>{{trans('mail.receiver')+': '+email_log.to_address}}</p>
                        </div>
                        <div class="linear-email-modal__body" v-html="email_log.body"></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" data-dismiss="modal">{{trans('general.close')}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: {},
        data(){
            return {
                email_logs: {
                    total: 0,
                    data: []
                },
                filterEmailLogForm: {
                    page_length: helper.getConfig('page_length')
                },
                email_log: {}
            };
        },
        mounted(){
            if(!helper.featureAvailable('email_log')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            this.getEmailLogs();
        },
        methods: {
            getEmailLogs(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterEmailLogForm);
                axios.get('/api/email-log?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.email_logs = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            fetchEmailLog(email_log){
                axios.get('/api/email-log/'+email_log.id)
                    .then(response => response.data)
                    .then(response => {
                        this.email_log = response;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            confirmDelete(email_log){
                return dialog => this.deleteEmailLog(email_log);
            },
            deleteEmailLog(email_log){
                axios.delete('/api/email-log/'+email_log.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getEmailLogs();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            }
        },
        filters: {
          moment(date) {
            return helper.formatDateTime(date);
          }
        }
    }
</script>

<style scoped>
.linear-page-hero {
    align-items: center;
}

.linear-eyebrow,
.linear-section-head span,
.linear-email-modal__head span {
    color: #635bff;
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.linear-section-head h4,
.linear-email-modal__head h4 {
    margin: 0.25rem 0 0;
    color: #0f172a;
    font-size: 1rem;
    font-weight: 800;
    letter-spacing: -0.03em;
}

.linear-section-head--table {
    margin: 0;
    padding: 0.95rem 1.125rem;
    border-bottom: 1px solid #e2e8f0;
}

.linear-table-card,
.linear-empty-state {
    overflow: hidden;
    border-radius: 14px;
}

.linear-dense-table tbody td {
    vertical-align: middle;
}

.linear-table-primary {
    color: #0f172a;
    font-weight: 800;
}

.linear-table-muted {
    color: #64748b;
}

.linear-table-truncate {
    display: block;
    max-width: 32rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.linear-email-modal {
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;
}

.linear-email-modal__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    background: #f8fafc;
}

.linear-email-modal__head time,
.linear-email-modal__meta {
    color: #64748b;
    font-size: 0.8125rem;
}

.linear-email-modal__meta {
    display: grid;
    gap: 0.35rem;
    margin-bottom: 1rem;
}

.linear-email-modal__meta p {
    margin: 0;
}

.linear-email-modal__body {
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    background: #ffffff;
    color: #334155;
}

@media (max-width: 575.98px) {
    .linear-page-hero,
    .linear-email-modal__head {
        align-items: flex-start;
    }

    .linear-email-modal__head {
        flex-direction: column;
    }
}
</style>
